"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toast = exports.Toasts = exports.ToastComponent = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHotToast = _interopRequireWildcard(require("react-hot-toast"));
var _Icon = require("../Basics/Icons/Icon");
var _styles = require("./styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const ToastComponent = ({
  notification,
  params,
  t = {},
  hideIcon = false,
  hideClose = false
}) => {
  const {
    msg,
    type,
    className,
    icon,
    style
  } = notification;
  const {
    _handleDismiss,
    _injectedCount
  } = t;
  const renderIcon = icon || (type === 'error' ? 'status-warning' : 'status-ok');
  return /*#__PURE__*/_react.default.createElement(_styles.Toast, {
    className: className,
    style: style,
    role: 'status'
  }, !hideIcon && /*#__PURE__*/_react.default.createElement(_styles.ToastIcon, null, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    "aria-label": "toast status icon",
    icon: renderIcon
  })), /*#__PURE__*/_react.default.createElement(_styles.ToastContent, null, msg(_objectSpread({
    count: _injectedCount
  }, params)), "  "), !hideClose && /*#__PURE__*/_react.default.createElement(_styles.ToastClose, {
    onClick: _handleDismiss,
    title: 'close'
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: "close"
  })));
};
exports.ToastComponent = ToastComponent;
ToastComponent.propTypes = {
  notification: _propTypes.default.shape({
    msg: _propTypes.default.func,
    type: _propTypes.default.string,
    className: _propTypes.default.string,
    icon: _propTypes.default.string,
    style: _propTypes.default.object
  }),
  params: _propTypes.default.object,
  t: _propTypes.default.shape({
    id: _propTypes.default.string,
    _injectedCount: _propTypes.default.number,
    _handleDismiss: _propTypes.default.func // For running tests only
  }),

  hideIcon: _propTypes.default.bool,
  hideClose: _propTypes.default.bool
};

// ID is required if immediate=true
const toast = (notification, params = {}, toastOptions = {}) => {
  const {
    id,
    immediate,
    duration
  } = notification;
  (0, _reactHotToast.default)(t => /*#__PURE__*/_react.default.createElement(ToastComponent, {
    notification: notification,
    params: params,
    t: t
  }), _objectSpread(_objectSpread(_objectSpread({}, !immediate ? {
    id
  } : {}), duration ? {
    duration
  } : {}), toastOptions));
};
exports.toast = toast;
class Event {
  constructor(createdAt, count = 1) {
    this.createdAt = createdAt;
    this.count = count;
    this.deleteTimeout = null;
  }
  clearDeleteTimeout() {
    if (this.deleteTimeout) {
      clearTimeout(this.deleteTimeout);
    }
  }
}
const Toasts = ({
  toasterProps,
  wrapperProps,
  testEnvironment = false
}) => {
  const events = {}; // <notificationId>: Event()

  const handleEvents = t => {
    const {
      id,
      createdAt,
      visible
    } = t;
    if (id in events) {
      const event = events[id];
      if (visible === false) {
        // Delete the id after the 0.2s animation is finished,
        // otherwise during the fade-out animation your message will receive count=1
        event.clearDeleteTimeout(); // Just in case
        event.deleteTimeout = setTimeout(() => delete events[id], 200);
      } else {
        if (createdAt !== event.createdAt) {
          // If another event came during the deleteTimeout,
          // cancel the deletion of the id and increment the count
          event.clearDeleteTimeout();
          event.createdAt = createdAt;
          event.count += 1;
        }
      }
    } else {
      events[id] = new Event(createdAt);
    }
  };
  const _resolveValue = t => {
    handleEvents(t);
    return (0, _reactHotToast.resolveValue)(t.message, _objectSpread(_objectSpread({}, t), {}, {
      _injectedCount: events[t.id].count,
      _handleDismiss: () => {
        if (testEnvironment) {
          handleEvents(_objectSpread(_objectSpread({}, t), {}, {
            visible: false
          }));
          _reactHotToast.default.remove(t.id);
        } else {
          _reactHotToast.default.dismiss(t.id);
        }
      }
    }));
  };
  return /*#__PURE__*/_react.default.createElement(_reactHotToast.Toaster, {
    position: "bottom-right",
    reverseOrder: true,
    toastOptions: _objectSpread({
      animation: 'none',
      duration: 5000
    }, toasterProps)
  }, t => /*#__PURE__*/_react.default.createElement(_styles.ToastWrapper, _extends({
    visible: t.visible
  }, wrapperProps), _resolveValue(t)));
};
exports.Toasts = Toasts;
Toasts.propTypes = {
  toasterProps: _propTypes.default.object,
  wrapperProps: _propTypes.default.object,
  testEnvironment: _propTypes.default.bool
};